export {};

const nativeFetch = window.fetch.bind(window);

window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
  const url = typeof input === "string" ? input : input instanceof URL ? input.pathname : input.url;
  if (url === "/api/auth/change-password" && init?.method === "POST" && document.querySelector(".student-space")) {
    try {
      const body = typeof init.body === "string" ? JSON.parse(init.body) : {};
      return nativeFetch("/api/student/change-password", {
        ...init,
        body: JSON.stringify({ newPassword: body.newPassword ?? "" }),
      });
    } catch { /* laisser le comportement normal en cas de payload inattendu */ }
  }
  return nativeFetch(input, init);
};

function adaptStudentPasswordForm() {
  if (!document.querySelector(".student-space")) return;
  const form = document.querySelector<HTMLFormElement>(".student-space .password-form");
  if (!form || form.dataset.studentPasswordAdapted) return;
  form.dataset.studentPasswordAdapted = "true";
  const current = form.querySelector<HTMLInputElement>('input[autocomplete="current-password"]');
  current?.closest("label")?.remove();
}

const observer = new MutationObserver(adaptStudentPasswordForm);
observer.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(adaptStudentPasswordForm, 0);
